<div class="wrap p-b-3-s no-scrollbar overflow-auto no-wrap">
    @for (item of component?.links; track item) {
    <div class="inline-block m-r-6">
        <href [link]="item.link"
              [hrefClass]="'link'"
              class="p1"
              *iCms="'label' of item"></href>
    </div>
    }
</div>
